import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function CostSection() {
  return;
}